<template>
<div>
  <div class="row">
    <div v-if="this.$t('arealuno.Idioma') == 'es'" class="flex xs12 md3  espww ">
      <br>
       <!-- <va-card class="titulo">  -->
          <p class="text-center display-3">FACULTAD DE POSGRADO</p>
            <hr>
          <div v-for="(curso,index) in getGradeCurricular" :key="index"  class="display-5 my-2 text-center">
            <va-button type="submit" @click="mudar_curso(curso)"  color="info"  class="my-0 tamanho">{{curso.nome_curso}}</va-button>
          </div>
      <!-- </va-card> -->
   
    </div>

    <div v-if="this.$t('arealuno.Idioma') == 'pt'" class="flex xs12 md3  espww">
      <br>
       <!-- <va-card class="titulo">  -->
          <p class="text-center display-3">FACULTAD DE POSGRADO</p>
            <hr>
          <div v-for="(curso,index) in getGradeCurricular" :key="index"  class="display-5 my-2 text-center">
            <va-button type="submit" @click="mudar_curso(curso)"  color="info"  class="my-0 tamanho">{{curso.nome_pt}}</va-button>
          </div>
      <!-- </va-card> -->
   
    </div>
    <div class="flex xs12 md9 espww"> 
            <div class="pa-3">
              <router-view/>
            </div>
         
    </div>
  </div>

    <div class="row xs12 md12 nav">
      <div class="flex xs12 md1 back mobile">
      <a href="https://www.posgrado.ucpvirtual.com.br/" target="_blank"><img class="logo" src="../imgs/logo-black.png" title="UCP Universidade central do Paraguai"></a>
      </div>
        <!-- <div class="flex xs12 md1 back">
      <a href="https://www.medicinaucp.com/" target="_blank"><img class="logo" src="./imgs/logo-black.png" title="UCP Universidade central do Paraguai"></a>
        </div> -->
      <div class="row row-separated pad ">
          <!-- <div class="flex xs2">+556799999999</div> -->
          <div class="flex xs2 mobile"><i class="va-icon fa fa-whatsapp" style="font-size: 20px; padding: 3px;"> +595 994 284911</i></div>
          <div class="flex xs2 mobile"><i class="va-icon fa fa-whatsapp" style="font-size: 20px; padding: 3px;"> +595 991 786469</i></div>
          <div class="flex xs2 mobile"><i class="va-icon ion ion-ios-mail" style="font-size: 20px; padding: 3px;"> sga@central.edu.py</i></div>
        <div class="flex xs3 md3 bnt">
       
       </div>  
       <va-button  type="submit" @click="Logar()" color="dark" class="bnt app-navbar__actions row flex-nowrap align--center">
           
            {{$t('arealuno.Logar')}}
       </va-button>   
        <div class="btn app-navbar__actions row flex-nowrap align--center">
           <language-dropdown class="va-navbar__item"/>
        </div>
    </div>
    </div>

</div>
</template>

<script>
import LanguageDropdown from '../dropdown/LanguageDropdown'

const tabs = [
  'login',
  'administrativo',

]

export default {
  name: 'AuthLayout',
  components: {
    LanguageDropdown,
  },
  data () {
    return {
      selectedTabIndex: 0,
      tabTitles: ['login', 'professores'],

      user: '',
      password: '',
    }
  },
  created(){
this.allCursos()
  },
  computed: {
    
    tabIndex: {
      set (tabIndex) {
        this.$router.push({ name: tabs[tabIndex] })
      },
      get () {
        return tabs.indexOf(this.$route.name)
      },
      
    },
    getGradeCurricular (){
        return  this.$store.state.gradecurricular.gradecurricular   
    },
  },
  methods:{
    allCursos() {
      let grade = this.$store.dispatch('allGradeCurricular')
    },
    mudar_curso(curso){
  
       this.$store.dispatch('getInfoGrade',curso)
       this.$store.dispatch('getDisciplinaGrade',curso)
        this.$router.push({ name: 'inscricao/informacoes' })
  
    },
    Logar(){
      this.$router.push({ name: 'login' })
    }
    
  }
}
</script>

<style lang="scss" scoped>
.auth-layout {
  min-height: 100vh;
  background-image: linear-gradient(to right, #4d77c9, #72819e);

  &__card {
    width: 100%;
    max-width: 600px;
  }

  &__options {
    @include media-breakpoint-down(xs) {
      flex-direction: column;
    }
  }
}
.back :hover {
  background-color: cornflowerblue;
}
#titulo {
  font-family: 'Studeo Bold' !important;
  text-align: justify;
  opacity: .8;
  color: #3c079e;
  font-size: 40px;
}
 #cor {
  background-color: #fff;
  color: #626262;
  opacity: .8;
  text-align: justify;
}
.tamanho {
  width: 100%;
  text-align: justify;
}

.espww {
  margin-top: 70px;
  opacity: 1;
}
.nav {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  background-color: white;
  opacity: .9;
  text-align: center;
}
.imag {
  width: 100%;
}
.logo {
  padding-top: 3px;
  width: 50px;
}
// body {
//    background-image: url('../imgs/teste.jpg');
//   background-size: cover;
// }

</style>
